package com.daytimegaming.ourdailyfinances

import androidx.compose.runtime.Composable

class WebPlatform : Platform {
    override val name: String = "Web Browser"
    override val buildVersion: String = "1.0.22 (23)"
}

actual fun getPlatform(): Platform = WebPlatform()

@Composable
actual fun getAndroidActivity(): Any? {
    return null
}
